import React from 'react';
interface SectionProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  className?: string;
  containerClassName?: string;
  id?: string;
}
export function Section({
  children,
  className = '',
  containerClassName = '',
  id,
  ...props
}: SectionProps) {
  return <section id={id} className={`py-16 md:py-24 w-full ${className}`} {...props} data-id="element-358">
      <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${containerClassName}`} data-id="element-359">
        {children}
      </div>
    </section>;
}